import React from 'react';

// TODO: create custom currency renderer with country image
const CurrencyCustomBodyRender = (props) => {
  return <span>{props.currency}</span>;
};

export default CurrencyCustomBodyRender;
